import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=e03da684&"
import script from "./TeamPage.vue?vue&type=script&lang=js&"
export * from "./TeamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TeamMemberList: require('/vercel/path0/components/team/TeamMemberList.vue').default,ComponentLoader: require('/vercel/path0/components/general/ComponentLoader.vue').default})
